import React from 'react';
import PropTypes from 'prop-types';

const IconPowertrainGuideHelp = ({ width = 48, height = 48, color = '#000000' }) =>
    <svg width={width} height={height} viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path d='M42 45V11L41 10H15L14 11V45L15 46H41L42 45ZM40 44H16V12H40V44Z' fill={color} />
        <path d='M37 15H19V17H37V15ZM37 19H19V21H37V19ZM37 23H19V25H37V23ZM32 27H19V29H32V27ZM10 7V42H12V8H39V6H11L10 7ZM6 3V38H8V4H35V2H7L6 3Z' fill={color} />
    </svg>;

IconPowertrainGuideHelp.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default IconPowertrainGuideHelp;
